import { Col, Modal, Row, Select, Spin, notification } from 'antd'
import React ,{useEffect, useRef} from 'react'
import FloatLabel from '../../components/FloatLabel/floatLabel'
import Button from '../../components/Buttons/Button';
import { addOrUpdateOBOConfig, fetchBuAndClientDetails_Opportunity, fetchFinanacialSpoc } from '../../store/reducers/orderDashboardSlice';
import { useDispatch, useSelector } from 'react-redux';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import './AddOboAccount.css';
import Link from 'antd/es/typography/Link';

const AddOboAccount = (props:any) => {

    const dispatch = useDispatch();
    const orderDashboardData = useSelector((state: any) => state.orderDashboard);
    const selectRef = useRef<any>(null);
    const [selectedClient, setSelectedClient] = React.useState<any>([]);
    const [clientList, setClientList] = React.useState<any>([]);
    const [accountOwner, setAccountOwner] = React.useState<any>([]);
    const [accountOwnerList, setAccountOwnerList] = React.useState<any>([]);

    useEffect(() => {

        if(props.visible){
            if(clientList.length === 0){
                setClientList( orderDashboardData.opportunity_clientEntityList)
            }
            
            if(accountOwnerList.length === 0){
                dispatch(fetchFinanacialSpoc({roleNameval: 'Sales'})).then(
                    (res: any) => {
                        if (res.type === 'orderDashboard/fetchFinanacialSpoc/fulfilled') {
                            setAccountOwnerList(res.payload);
                            
                          }else{
                            rejectedApiMessage(res.payload);
                          }
                    }
                );
            }
            if(props.configType === 'edit'){
                let temp:any = props.selectedClient.clientName;
                setSelectedClient([temp]);
                setAccountOwner(getAccountOwnerList());
            }
            
        }
        else{
            setSelectedClient([]);
            setAccountOwner([]);
        }

    }, [props.visible]);

    const getAccountOwnerList = () => {
      const emaillist=props.selectedClient.accountOwner.split(',').map((item:any)=>{return {email:item}});
      const _accountOwnerList=emaillist.map((item:any)=>{
        if(accountOwnerList.length>0){
          const _empDetails= accountOwnerList.find((element:any)=>element.email===item.email)
          if(_empDetails ){
            return {key:_empDetails.email,label:_empDetails.name,value:_empDetails.email}
          }
          else{
            return {key:item.email,label:item.email,value:item.email}
          }
        }
        else{
          return {key:item.email,label:item.email,value:item.email}
        }
      });
      return _accountOwnerList;
    }


    const handleChangedValue = (type: any, value: any) => {
        if (type === 'client') {
          setSelectedClient(value);
        }
        if (type === 'accountOwner') {
          setAccountOwner(value);
        }
      };

      const fetchemployeeIds = (employeeList: any) => {
        let employeeIds: any = [];
        employeeList.forEach((element: any) => {
            accountOwnerList.forEach((item: any) => {
              if (element.key === item.email) {
                employeeIds.push(item.id);
              }
            });
        });
        return employeeIds;
      }
      const _fetchRemovedemployeeIds = (employeeList: any) => {
        let employeeIds: any = [];
        employeeList.forEach((element: any) => {
            accountOwnerList.forEach((item: any) => {
              if (element === item.email) {
                employeeIds.push(item.id);
              }
            });
        });
        return employeeIds;
      }
      const handleSubmit = () => {
        const values={
            "clientName": selectedClient,
            "type": props.configType,
            "employeeId": fetchemployeeIds(accountOwner),
            "removedEmployeeId": props.configType=="edit"?fetchremovedEmployeeIds(getAccountOwnerList(),accountOwner):[]
        };

        dispatch(addOrUpdateOBOConfig({'values':values})).then(
            (res: any) => {
                if (res.type === 'orderDashboard/addOrUpdateOBOConfig/fulfilled') {
                  notification.success({
                    message: 'Success',
                    description: `Account Owner ${props.configType==="edit"?'updated':'added'} successfully`,
                  });
                    props.onSubmit();
                  }else{
                    rejectedApiMessage(res.payload);
                  }
            }
        );
      }
    
    const fetchremovedEmployeeIds = (oldList: any, newList: any) => {
        let removedEmployeeIds: any = [];
        oldList.forEach((element: any) => {
          let found = newList.find((item: any) => item.key === element.key);
          if (!found) {
            removedEmployeeIds.push(element.key);
          }
        });
        return _fetchRemovedemployeeIds(removedEmployeeIds)
        
    }
    const handleSelectAll = () => {
      setSelectedClient(clientList);
    }
  return (
    <Modal
    title={props.configType==="edit"?"Edit Configuration" :"Add Configuration"}
    open={props.visible}
    onCancel={()=>props.onCancel()}
    footer={null}
    maskClosable={false}
    // width={1000}
    styles={{
      content: {
        borderRadius: '0',
        borderTop: '4px solid #1677ff',
        font: 'normal normal normal 14px/20px Nunito Sans',
        zIndex: 9998,
      },
    }}
    >
    <Spin spinning={orderDashboardData.loading} >
    <div className='obo-account-owners-field' >
        <FloatLabel label="Client Name *" isMultiSelect={true} value={selectedClient.map((item: any) => item.name)}>
            <Select
              // showSearch
              autoClearSearchValue
              mode="multiple"
              size='middle'
              ref={selectRef}
              className='AccountOwner-select'
              // style={{ width: 200 }}
              style={{ width: '100%',
                //  height: 65,
                  marginRight: '10px' }}
              // placeholder="Select Client Entity"
              optionFilterProp="children"
              value={selectedClient.map((item: any) => item)}
              // onSelect={(value: string) => handleChangedValue('client', value)}
              disabled={props.configType === "edit"}
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              onChange={(value: string | string[]) => { handleChangedValue('client', value) }}
              filterOption={(input: any, option: any) =>
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }

              options={clientList.map((item: any) => ({ value: item }))}
              dropdownRender={menu => (
                <>
                <div style={{display:'flex', justifyContent:'space-around', margin:'5px'}}>
                <Link onClick={()=>handleSelectAll()} disabled={selectedClient.length===clientList.length} >Select All</Link>
                <Link onClick={()=>handleChangedValue('client',[])} disabled={selectedClient.length==0}>Clear All</Link>
                </div>
                {menu}
                </>
              )}
            >
            </Select>
          </FloatLabel>
    </div>
    <div className='obo-account-owners-field' >
        <FloatLabel label="Account Owners *" isMultiSelect={true} value={accountOwner.map((item: any) => item.name)}>
            <Select
              autoClearSearchValue
              mode="multiple"
              size='middle'
              ref={selectRef}
              className='AccountOwner-select'
              style={{ width: '100%', marginRight: '10px' }}
              optionFilterProp="children"
              value={accountOwner.map((item: any) => item)}
              // onSelect={(value: string | string[]) => handleChangedValue('financialSpoc', value)}
              onChange={(value: string | string[]) => { handleChangedValue('accountOwner', value) }}
              labelInValue
              filterOption={(input: any, option: any) =>
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={accountOwnerList.map((item: any) => ({ value: item.email, label: item.name }))}
            >
            </Select>
          </FloatLabel>
    </div>
    <div style={{marginTop:'20px ', display:'flex', justifyContent:'end'}}>   

            <Button type='cancel' label='Cancel' key="cancel" onClick={()=>props.onCancel()} ></Button>


            <Button type='submit' label='Submit' key="add-account-owner" disabled={!selectedClient || !(accountOwner.length>0)} onClick={()=>handleSubmit() } ></Button>

        
    </div>
    </Spin>
    </Modal>
  )
}


export default AddOboAccount